import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface AdminApprovalLimitUpdateProps {
  adminApprovalTokenLimit: number;
}

export const useUpdateAdminApprovalLimit = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateReviewerConfig = async (data: AdminApprovalLimitUpdateProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/org/admin-approval-limit`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to update admin approval limit');
    }
  };

  return useMutation({
    mutationFn: updateReviewerConfig,
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.User]);
    },
  });
};
